module.exports = __webpack_public_path__ + "img/jira_help.1fe752d8.svg";